export class TokenInfo {
    possuiTokenMobile: boolean;
    possuiTokenCartao: boolean;
    numeroCartao: string;
}
